import type { EventContent, LiveInfo } from "@tih/shared";
import { isBroadcastLive } from "./live-display";

/** Homepage reserve becomes check-in while the livestream is on and the night is ongoing. */
export function shouldOfferPublicCheckIn(
  liveInfo: LiveInfo | null | undefined,
  eventPhase: EventContent["eventPhase"] | undefined,
): boolean {
  return isBroadcastLive(liveInfo) && eventPhase === "ongoing";
}
